/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: Record<string, GenericFormItem[]> = {
  behaviorMode: [
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MODE_KEY',
      stateKey: 'mode',
      isSelect: true,
      options: [
        { value: 'manual', label: 'MANUAL_KEY' },
        { value: 'period', label: 'PERIODS_KEY' },
        { value: 'micro', label: 'Micro' },
        { value: 'spot_period', label: `${i18n.t('PERIODS_KEY')}(Spot)` },
      ],
    },
    {
      gridXs: 6,
      validateOnChange: true,
      label: 'TIME_ZONE_KEY',
      stateKey: 'timeZone',
      isSelect: true,
      options: [],
    },
  ],
};

export default fields;
